import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11.5,
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12.0625,
			y1: 9.625,
			x2: 12.0625,
			y2: 18.625,
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 6,
			r: .5,
			stroke: "black"
		})
	]
});
export default SvgInfo;
